module.exports = __webpack_public_path__ + "static/media/banner.bb703662.webm";